var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg4HoursFreshFromFridge(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 200 200"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M100 155.61a51 51 0 1151-51 51 51 0 01-51 51zm0-95.07a44.1 44.1 0 1044.1 44.09A44.15 44.15 0 00100 60.54z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M111.73 60.54H88.27V44.39h23.46zm-16.57-6.89h9.68v-2.38h-9.68z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M83.76 44.39h32.48v6.89H83.76zM127.627 67.532l8.047-8.047 10.006 10.006-8.047 8.046z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M130.547 62.11l4.872-4.871 12.494 12.494-4.872 4.872zM120.06 119.85l-23.5-15.01V66.92h6.88v34.14l20.33 12.99-3.71 5.8z"
  })));
}
export default Svg4HoursFreshFromFridge;